import { ApiError } from '../../services/api';

/** Which part of the modal an error belongs to, so the message sits next to the field (a11y). */
export type RescheduleErrorField = 'date' | 'returnDate' | 'slot' | 'capacity' | 'form';

export interface RescheduleError {
  field: RescheduleErrorField;
  message: string;
  /** 409: the order changed under the admin; the modal closes and the page reloads. */
  conflict: boolean;
}

const MESSAGES: Record<string, [RescheduleErrorField, string]> = {
  RESCHEDULE_DISABLED: ['form', 'Rescheduling is switched off right now.'],
  NOT_RESCHEDULABLE: ['form', "This order can't be rescheduled in its current status."],
  LEG_IN_PROGRESS: ['form', 'The trip has already started, so this part can no longer be changed.'],
  DATE_IN_PAST: ['date', 'Pick a date from today on.'],
  RETURN_BEFORE_PICKUP: ['returnDate', 'The return date must be on or after the booking date.'],
  SLOT_INVALID: ['slot', "That time slot isn't available. Pick another one."],
  SLOT_REQUIRED: ['slot', 'Pick a time slot for each trip Garagat drives.'],
  FIELD_NOT_EDITABLE: ['form', "One of those fields can't be changed at this stage. Close and reopen to see what can."],
  ZOFEUR_NOT_AVAILABLE_FOR_ADDRESS: ['form', "Zofeur doesn't cover this address."],
  CAPACITY_CONFIRM_REQUIRED: ['capacity', 'The garage is full that day. Tick "Garage agreed to take the car" to continue.'],
  NOTHING_CHANGED: ['form', 'Nothing changed. Pick a different date or time slot.'],
};

/** Maps the `code` of the error envelope (design §3) to a friendly inline message. */
export function toRescheduleError(err: unknown): RescheduleError {
  if (err instanceof ApiError) {
    const known = err.code ? MESSAGES[err.code] : undefined;
    return {
      field: known?.[0] ?? 'form',
      message: known?.[1] ?? err.serverMessage ?? 'Could not reschedule the order. Please try again.',
      conflict: err.status === 409 && err.code === 'ORDER_CHANGED',
    };
  }
  return { field: 'form', message: 'Could not reschedule the order. Please try again.', conflict: false };
}
